import { Api_EndPoints } from "../utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "../utils/http_payroll";

const getEmpAppliedLeaves = async ({
  companyCode,
  fromDate,
  toDate,
  locationCode,
  employeeCode,
  departmentCode,
  isAllCompanies = false,
  userId = 0,
  selectedCompanyCode = "",
  status = "All",
}) => {
  let queryString = `?IsAllCompanies=${isAllCompanies}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LeaveFrom=${fromDate}&LeaveTo=${toDate}&LocationCode=${locationCode}`;

  if(status !== "All") {
    queryString += `&Status=${Number(status)}`;
  } else {
    queryString += `&Status=${status}`;
  }

  if (employeeCode) {
    queryString += `&EmployeeCode=${employeeCode}`;
  }

  if (departmentCode) {
    queryString += `&DepartmentCode=${departmentCode}`;
  }

  if (isAllCompanies) {
    queryString += `&UserId=${userId}`;
  }

  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmpAppliedLeavesList}${queryString}`,
  );
  return data;
};

const getEmpAppliedLeaveDetails = async ({
  companyCode,
  employeeCode,
  code,
}) => {
  const queryString = `?companyCode=${companyCode}&EmployeeCode=${employeeCode}&Code=${code}`;

  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmpLeavesList}${queryString}`,
  );
  return data;
};

export const useGetEmpAppliedLeaveQuery = (input) => {
  
  

  return useQuery({
    queryKey: [Api_EndPoints.EmpAppliedLeavesList, input],
    queryFn: () => getEmpAppliedLeaves(input),
  });
};

export const useGetEmpAppliedLeaveDetailsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmpLeavesList, input],
    queryFn: () => getEmpAppliedLeaveDetails(input),
  });
};
